module.exports = __webpack_public_path__ + "img/No-Results-Found.38de0534.svg";